module.exports = __webpack_public_path__ + "img/space-introduce-4.7c3446c4.svg";